import { Controller } from '@hotwired/stimulus'
import { api } from '../../api'

type IntegrationOptions = Array<[string, string]>

export default class IntegrationController extends Controller<HTMLElement> {
  declare readonly accountTypeOptionsTarget: HTMLElement
  declare readonly taxQualifiedTypeOptionsTarget: HTMLElement
  declare identityValue: String
  declare nameValue: String

  static targets = ['accountTypeOptions', 'taxQualifiedTypeOptions']
  static values = {
    identity: String,
    name: String,
  }

  fetchLatestRedtailOptionData() {
    api.integrations
      .search({ identity: this.identityValue, name: this.nameValue })
      .then(response => response.json)
      .then(data => {
        this.updateOptions(this.accountTypeOptionsTarget, data.account_types)
        this.updateOptions(this.taxQualifiedTypeOptionsTarget, data.tax_qualified_types)
        // This is only dispatched so a test knows we reached this point
        this.dispatch('updated-redtail-options', { bubbles: true })
      })
  }

  updateOptions(target: HTMLSelectElement, options: IntegrationOptions) {
    target.innerHTML = options
      .map(([label, value]) => {
        return `<option value='${value}'>${label}</option>`
      })
      .join('')
  }
}
